import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const messagingApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    responseHandler: async (response) => {
      const text = await response.text()

      try {
        return JSON.parse(text)
      } catch {
        // If backend sent HTML, return raw text so we can see it
        return { raw: text }
      }
    },
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "messagingApi",
  tagTypes: ["Quiz", "Answer"],
  endpoints: (builder) => ({
    getTeamMembers: builder.mutation<any, void>({
      query: () => ({
        url: "/messages/teammembers",
        method: "POST",
      }),
    }),

    getTeamMembersNotInThread: builder.mutation({
      query: (payload) => ({
        url: "/messages/teammembersnotinthread",
        method: "POST",
        body: payload,
      }),
    }),

    updateUsersInThread: builder.mutation({
      query: (payload) => ({
        url: "/messages/updateusersinthread",
        method: "POST",
        body: payload,
      }),
    }),

    getThreads: builder.mutation({
      query: (payload) => ({
        url: "/messages/threads",
        method: "POST",
        body: payload,
      }),
    }),

    readThread: builder.mutation({
      query: (payload) => ({
        url: "/messages/readthread",
        method: "POST",
        body: payload,
      }),
    }),

    createThread: builder.mutation({
      query: (payload) => ({
        url: "/messages/addthread",
        method: "POST",
        body: payload,
      }),
    }),

    getMessages: builder.mutation({
      query: (payload) => ({
        url: "",
        method: "POST",
        body: payload,
      }),
    }),

    sendMessage: builder.mutation({
      query: (payload) => ({
        url: "messages/sendmessage",
        method: "POST",
        body: payload,
      }),
    }),
  }),
})

export const {
  useCreateThreadMutation,
  useGetMessagesMutation,
  useGetTeamMembersMutation,
  useGetTeamMembersNotInThreadMutation,
  useGetThreadsMutation,
  useReadThreadMutation,
  useSendMessageMutation,
  useUpdateUsersInThreadMutation,
} = messagingApi
